// Google Analytics Event Tracking Utilities

declare global {
  interface Window {
    dataLayer: any[]
    gtag: (...args: any[]) => void
  }
}

const GA_MEASUREMENT_ID = 'G-75H8FC5Q21'

/**
 * Check if Google Analytics is loaded
 */
const isGALoaded = (): boolean => {
  return typeof window !== 'undefined' && typeof window.gtag === 'function'
}

/**
 * Track a custom event in Google Analytics
 * @param eventName - Name of the event (e.g., 'cta_click', 'form_submit')
 * @param eventParams - Additional parameters for the event
 */
export const trackEvent = (
  eventName: string,
  eventParams?: Record<string, any>,
) => {
  if (isGALoaded()) {
    window.gtag('event', eventName, eventParams)
    console.log('GA Event:', eventName, eventParams) // Debug log
  } else {
    console.warn('Google Analytics not loaded yet')
  }
}

/**
 * Track page views (useful for SPAs)
 * @param path - Page path
 * @param title - Page title
 */
export const trackPageView = (path: string, title?: string) => {
  if (isGALoaded()) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: path,
      page_title: title,
    })
    console.log('GA Page View:', path, title) // Debug log
  }
}

/**
 * Track CTA button clicks
 * @param location - Where the CTA was clicked (e.g., 'hero', 'footer', 'nav')
 */
export const trackCTAClick = (location: string) => {
  trackEvent('cta_click', {
    event_category: 'engagement',
    event_label: location,
    location,
    destination: 'https://app.watchdog.buzz/',
  })
}

/**
 * Track section visibility (scroll tracking)
 * @param sectionName - Name of the section that became visible
 */
export const trackSectionView = (sectionName: string) => {
  trackEvent('section_view', {
    event_category: 'engagement',
    event_label: sectionName,
    section: sectionName,
  })
}

/**
 * Track outbound link clicks
 * @param url - Destination URL
 * @param linkText - Text of the link
 */
export const trackOutboundLink = (url: string, linkText?: string) => {
  trackEvent('outbound_click', {
    event_category: 'outbound',
    event_label: url,
    url,
    link_text: linkText,
  })
}
